<div class="funnel-chart-container">
  <h2 class="h2-bold primary-100">
    <span class="arrow-icon">→</span> {{ chartData.overallConversion }}%
    <span class="h3-reg primary-60">Overall Conversion</span>
  </h2>

  <div class="chart-wrapper">
    <svg #funnelSvg class="funnel-svg">
      <g [attr.transform]="'translate(' + margin.left + ',' + margin.top + ')'">
        <!-- Y axis labels -->
        <text
          *ngFor="let label of yAxisLabels; let i = index"
          [attr.x]="-10"
          [attr.y]="chartHeight - (i * chartHeight) / 5"
          class="h5-reg"
          fill="var(--primary-60)"
          text-anchor="end"
          alignment-baseline="middle">
          {{ label }}
        </text>

        <!-- Horizontal grid lines -->
        <line
          *ngFor="let label of yAxisLabels; let i = index"
          [attr.x1]="0"
          [attr.y1]="chartHeight - (i * chartHeight) / 5"
          [attr.x2]="chartWidth"
          [attr.y2]="chartHeight - (i * chartHeight) / 5"
          class="grid-line" />

        <!-- Funnel bars -->
        <g *ngFor="let stage of chartData.stages; let i = index">
          <defs>
            <pattern
              [attr.id]="'pattern-' + i"
              patternUnits="userSpaceOnUse"
              width="10"
              height="10"
              patternTransform="rotate(45)">
              <line
                x1="0"
                y1="0"
                x2="0"
                y2="10"
                [attr.stroke]="stage.strokeColor"
                stroke-width="8" />
            </pattern>
          </defs>

          <!-- Ghost/striped bar -->
          <rect
            [attr.x]="getBarX(i)"
            [attr.y]="0"
            [attr.width]="getBarWidth()"
            [attr.height]="chartHeight"
            [attr.fill]="'url(#pattern-' + i + ')'"
            [attr.rx]="4"
            [attr.ry]="4"
            class="ghost-bar" />

          <!-- Actual data bar -->
          <rect
            [attr.x]="getBarX(i)"
            [attr.y]="getBarY(stage)"
            [attr.width]="getBarWidth()"
            [attr.height]="getBarHeight(stage)"
            [attr.fill]="stage.color"
            (mouseenter)="showTooltip($event, stage)"
            (mouseleave)="hideTooltip()"
            [attr.rx]="4"
            [attr.ry]="4"
            class="funnel-bar" />
        </g>

        <!-- X-axis labels and metrics -->

        <g *ngFor="let stage of chartData.stages; let i = index" class="funnel-labels">
          <text
            [attr.x]="getBarX(i)"
            [attr.y]="chartHeight + 30"
            class="h3-bold"
            fill="var(--primary-100)"
            text-anchor="start">
            {{ i + 1 }}. {{ stage.name }}
          </text>

          <g class="user-count-group">
            <text
              [attr.x]="getBarX(i)"
              [attr.y]="chartHeight + 50"
              class="arrow continue h3-bold"
              dominant-baseline="middle">
              →
            </text>
            <text
              [attr.x]="getBarX(i) + 24"
              [attr.y]="chartHeight + 50"
              class="h4-bold user-count"
              text-anchor="start"
              dominant-baseline="middle">
              <tspan class="count" fill="var(--primary-80)">
                {{ stage.customerCount?.toLocaleString() }} users
              </tspan>
              <tspan dx="4" class="percentage" fill="var(--primary-60)">
                ({{ getTotalConversionPercentage(stage) }}% converted)
              </tspan>
            </text>
          </g>

          <g *ngIf="stage.previousStage" class="drop-off-group">
            <text
              [attr.x]="getBarX(i)"
              [attr.y]="chartHeight + 70"
              class="arrow drop h3-bold"
              dominant-baseline="middle">
              ↘
            </text>
            <text
              [attr.x]="getBarX(i) + 24"
              [attr.y]="chartHeight + 70"
              class="h4-bold user-count"
              text-anchor="start"
              dominant-baseline="middle">
              <tspan class="count" fill="var(--primary-80)">
                {{ getDropOffCount(stage) }} users
              </tspan>
              <tspan dx="4" class="percentage" fill="var(--primary-60)">
                ({{ getDropOffPercentage(stage) }}% drop-off)
              </tspan>
            </text>
          </g>
        </g>
      </g>
    </svg>
  </div>

  @if (showTooltipFlag()) {
    <div
      class="custom-chart-tooltip"
      [ngClass]="{ visible: showTooltipFlag() }"
      [style.left.px]="tooltipPosition().x"
      [style.top.px]="tooltipPosition().y">
      <div class="d-flex flex-column spacing-8 align-items-start w-100">
        <h4 class="h4-bold primary-0 text-capitalize" style="margin: 0; color: white">
          {{ activeStage()?.name }}
        </h4>
        <span class="dash-border w-100"></span>

        <!-- Users count -->
        <div class="d-flex align-items-center justify-content-between spacing-8 w-100">
          <div class="d-flex align-items-center spacing-4 w-100 text-center">
            <div
              [style.background]="activeStage()?.color"
              class="tooltip-dot d-flex align-items-center h4-bold"></div>
            <div class="h4-reg primary-50">Users</div>
          </div>
          <div class="h4-bold primary-0">{{ activeStage()?.customerCount?.toLocaleString() }}</div>
        </div>

        <!-- Overall conversion till this stage -->
        <div class="d-flex align-items-center justify-content-between spacing-8 w-100">
          <div class="d-flex align-items-center spacing-4 w-100 text-center">
            <div class="h4-reg primary-50">Total Conversion</div>
          </div>
          <div class="h4-bold primary-0 white-space">
            {{ getTotalConversionPercentage(activeStage()!) }}%
          </div>
        </div>

        <!-- Conversion from previous step -->
        @if (activeStage()?.previousStage) {
          <div class="d-flex align-items-center justify-content-between spacing-8 w-100">
            <div class="d-flex align-items-center spacing-4 w-100 text-center">
              <div class="h4-reg primary-50">Conversion from previous step</div>
            </div>
            <div class="h4-bold primary-0 white-space">{{ getPercentage(activeStage()!) }}%</div>
          </div>
        }

        <!-- Drop-off data -->
        @if (activeStage()?.previousStage) {
          <div class="d-flex align-items-center justify-content-between spacing-8 w-100">
            <div class="d-flex align-items-center spacing-4 w-100 text-center">
              <div class="h4-reg primary-50">Drop-off</div>
            </div>
            <div class="h4-bold primary-0 white-space">
              {{ getDropOffCount(activeStage()!) }} users ({{
                getDropOffPercentage(activeStage()!)
              }}%)
            </div>
          </div>
        }
      </div>
    </div>
  }
</div>
